import Layout from '@layout/Index'

export const users = [
  {
    path: '/users',
    component: Layout,
    children: [
      {
        path: 'detail',
        component: () => import(/* webpackChunkName: "users-detail" */ './pages/detail/Index.vue'),
        children: [
          {
            path: 'info',
            component: () => import(/* webpackChunkName: "users-info" */ './pages/detail/UsersDetail.vue'),
            name: '用户详情',
            meta: {
              title: '用户详情',
            },
          },
          {
            path: 'service',
            component: () => import(/* webpackChunkName: "users-service" */ './pages/detail/UsersService.vue'),
            name: '客服记录',
            meta: {
              title: '客服记录',
            },
          },
          {
            path: 'account',
            component: () => import(/* webpackChunkName: "users-account" */ './pages/detail/UsersAccountDetail.vue'),
            name: '账户信息',
            meta: {
              title: '账户信息',
            },
          },
          {
            path: 'device',
            component: () => import(/* webpackChunkName: "users-device" */ './pages/detail/UsersDeviceDetail.vue'),
            name: '设备信息',
            meta: {
              title: '设备信息',
            },
          },
          {
            path: 'operate',
            component: () => import(/* webpackChunkName: "users-operate" */ './pages/detail/UsersOperateDetail.vue'),
            name: '运营信息',
            meta: {
              title: '运营信息',
            },
          },
          {
            path: 'log',
            component: () => import(/* webpackChunkName: "users-log" */ './pages/detail/UsersLogDetail.vue'),
            name: '管理日志',
            meta: {
              title: '管理日志',
            },
          },
          {
            path: 'workinfo-log',
            component: () => import(/* webpackChunkName: "workinfo-log" */ './pages/detail/UsersDetailWorkInfoLog.vue'),
            name: '工作信息记录',
            meta: {
              title: '工作信息记录',
            },
          },

        ],
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "users-table" */ './pages/UsersTable.vue'),
        name: '用户列表',
        meta: {
          title: '用户列表',
        },
      },
      {
        path: 'amount',
        component: () => import(/* webpackChunkName: "users-amount" */ './pages/UsersAmountTable.vue'),
        name: '金额详情',
        meta: {
          title: '金额详情',
        },
      },
      {
        path: 'point',
        component: () => import(/* webpackChunkName: "users-point" */ './pages/UsersPointTable.vue'),
        name: '积分详情',
        meta: {
          title: '积分详情',
        },
      },
      {
        path: 'mas',
        component: () => import(/* webpackChunkName: "users-mas" */ './pages/UsersMasTable.vue'),
        name: '群发消息',
        meta: {
          title: '群发消息',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "users-update" */ './pages/UsersForm.vue'),
        name: '修改用户',
        meta: {
          type: 'edit_user',
          title: '修改用户',
        },
      },
      {
        path: 'form',
        component: () => import(/* webpackChunkName: "users-form" */ './pages/UsersForm.vue'),
        name: '创建用户',
        meta: {
          type: 'add_user',
          title: '创建用户',
        },
      },
      {
        path: 'freeze/form/:userid',
        component: () => import(/* webpackChunkName: "users-freeze-formm" */ './pages/UsersFreezeForm.vue'),
        name: '修改封号',
        meta: {
          title: '修改封号',
        },
      },
      {
        path: 'batch/table',
        component: () => import(/* webpackChunkName: "users-batch" */ './pages/UserBatchTable.vue'),
        name: '批量用户',
        meta: {
          title: '批量用户',
        },
      },
      {
        path: 'user-account-table',
        component: () => import(/* webpackChunkName: "user-account-table" */ './pages/UsersAccountTable.vue'),
        name: '用户账户查询',
        meta: {
          title: '用户账户查询',
        },
      },
      {
        path: 'points-table',
        component: () => import(/* webpackChunkName: "points-table" */ './pages/UsersPointsTable.vue'),
        name: '零豆管理',
        meta: {
          title: '零豆管理',
        },
      },
      {
        path: 'communicate-table',
        component: () => import(/* webpackChunkName: "communicate-table" */ './pages/UserCommunicateTable.vue'),
        name: '用户沟通记录',
        meta: {
          title: '用户沟通记录',
        },
      },
      {
        path: 'deleted-table',
        component: () => import(/* webpackChunkName: "deleted-users-table" */ './pages/DeletedUsersTable.vue'),
        name: '注销用户列表',
        meta: {
          title: '注销用户列表',
        },
      },
      {
        path: 'devices',
        component: () => import(/* webpackChunkName: "users-device-relation-table" */ './pages/UserDeviceTable.vue'),
        name: '用户设备列表',
        meta: {
          title: '用户设备列表',
        },
      },
      {
        path: 'devices/user-list',
        component: () => import(/* webpackChunkName: "users-device-user-list" */ './pages/detail/UsersDeviceUserListTable.vue'),
        name: '设备关联记录',
        meta: {
          title: '设备关联记录',
        },
      },
      {
        path: 'newbie-config',
        component: () => import(/* webpackChunkName: "users-newbie-cfg" */ './pages/UsersNewbieCfg.vue'),
        name: '新用户定义配置',
        meta: {
          title: '新用户定义配置',
        },
      },
      {
        path: 'view-newbie-config',
        component: () => import(/* webpackChunkName: "users-newbie-cfg" */ './pages/UsersNewbieCfg.vue'),
        name: '新用户定义查看页',
        meta: {
          title: '新用户定义查看页',
          pageType: 'view',
        },
      },
      {
        path: 'newbie-mission-config',
        component: () => import(/* webpackChunkName: "newbie-mission-cfg" */ './pages/NewbieMissionCfg.vue'),
        name: '新手引导任务配置',
        meta: {
          title: '新手引导任务配置',
        },
      },
      {
        path: 'riskusers',
        component: () => import(/* webpackChunkName: "users-riskusers" */ './pages/RiskUserTable.vue'),
        name: '风险用户统计',
        meta: {
          title: '风险用户统计',
        },
      },
      {
        path: 'riskusers/detail/:id',
        component: () => import(/* webpackChunkName: "users-riskusers-detail" */ './pages/detail/RiskUserDetail.vue'),
        name: '风险用户统计详情',
        meta: {
          title: '风险用户统计详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/users/users.route.js